import React from 'react';

function EyeGazeOverlay({
                            leftIrisCenterPixel,
                            rightIrisCenterPixel,
                            eyesDirection, // e.g. { x: 0.2, y: -0.1 } from blendshapes
                            headAngles,    // e.g. { yaw: 5, pitch: -10, roll: 0 }
                            eyeWeight = 0.5,
                            headWeight = 1.5
                        }) {
    if (!leftIrisCenterPixel || !rightIrisCenterPixel || !eyesDirection || !headAngles) {
        return null;
    }

    const lineLength = 400;

    const { yaw, pitch, roll } = headAngles;

    const toRad = (deg) => (deg * Math.PI) / 180;

    function rotateX(v, angle) {
        const cosA = Math.cos(angle);
        const sinA = Math.sin(angle);
        return {
            x: v.x,
            y: v.y * cosA - v.z * sinA,
            z: v.y * sinA + v.z * cosA,
        };
    }

    function rotateY(v, angle) {
        const cosA = Math.cos(angle);
        const sinA = Math.sin(angle);
        return {
            x: v.z * sinA + v.x * cosA,
            y: v.y,
            z: v.z * cosA - v.x * sinA,
        };
    }

    function rotateZ(v, angle) {
        const cosA = Math.cos(angle);
        const sinA = Math.sin(angle);
        return {
            x: v.x * cosA - v.y * sinA,
            y: v.x * sinA + v.y * cosA,
            z: v.z,
        };
    }

    function applyYawPitchRoll(dir, yawDeg, pitchDeg, rollDeg) {
        let v = { ...dir };
        v = rotateX(v, toRad(pitchDeg));
        v = rotateY(v, toRad(yawDeg));
        v = rotateZ(v, toRad(rollDeg));
        return v;
    }

    const eyeVector = {
        x: eyesDirection.x * eyeWeight,
        y: eyesDirection.y * eyeWeight,
        z: -0.3,
    };

    let headVector = { x: 0, y: 0, z: -1 }; // Neutral forward gaze
    headVector = applyYawPitchRoll(headVector, yaw * headWeight, pitch * headWeight, roll * headWeight);

    const combinedVector = {
        x: eyeVector.x + headVector.x,
        y: eyeVector.y + headVector.y,
        z: eyeVector.z + headVector.z,
    };

    const magnitude = Math.sqrt(
        combinedVector.x ** 2 + combinedVector.y ** 2 + combinedVector.z ** 2
    );
    const normalizedVector = {
        x: combinedVector.x / magnitude,
        y: combinedVector.y / magnitude,
        z: combinedVector.z / magnitude,
    };

    const leftLineEnd = {
        x: leftIrisCenterPixel.x + normalizedVector.x * lineLength,
        y: leftIrisCenterPixel.y + normalizedVector.y * lineLength,
    };

    const rightLineEnd = {
        x: rightIrisCenterPixel.x + normalizedVector.x * lineLength,
        y: rightIrisCenterPixel.y + normalizedVector.y * lineLength,
    };


    return (
        <svg
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
            }}
        >
            <line
                x1={leftIrisCenterPixel.x}
                y1={leftIrisCenterPixel.y}
                x2={leftLineEnd.x}
                y2={leftLineEnd.y}
                stroke="red"
                strokeWidth={2}
            />
            <line
                x1={rightIrisCenterPixel.x}
                y1={rightIrisCenterPixel.y}
                x2={rightLineEnd.x}
                y2={rightLineEnd.y}
                stroke="red"
                strokeWidth={2}
            />
        </svg>
    );
}

export default EyeGazeOverlay;
